/**
 * Tipos del padrón WhatsApp.  (spec 052)
 */
export interface LineaPadron {
    e164: string
    phoneNumberId: string | null
    businessAccountId: string | null
    accountId: number | null
    negocio: string | null
    estadoAlta: string | null
    fuente: 'chatwoot' | 'meta' | 'ambas'
    libre: boolean
    callback: string | null
    verifyToken: string | null
}

export interface NegocioSinCanal {
    accountId: number
    name: string
    estadoAlta: string
    altaId: number | null
}

export interface PadronWhatsapp {
    lineas: LineaPadron[]
    negociosSinCanal: NegocioSinCanal[]
    sesionMeta: boolean
    /** Cuándo se pidió el listado a Facebook. Null: aún no, y esta pantalla no lo pide. */
    metaRefrescadoEn: string | null
}

export interface WebhookWhatsapp {
    e164: string | null
    callback: string | null
    verifyToken: string | null
}

export function lineasLibres(padron: PadronWhatsapp | undefined): LineaPadron[] {
    return (padron?.lineas ?? []).filter((l) => l.libre)
}
